module.exports = "<p>\n  breadcrumb works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/common/breadcrumb/breadcrumb.component.html
// module id = 1528
// module chunks = 2